import { http } from '@/core/api';
import { executeRequest } from '@/core/either';
import type { ApiResult } from '@/core/either';
// eslint-disable-next-line local-rules/architecture-boundaries -- deuda preexistente, anterior a ML-168: FilterTeamUsers y UsersTeamPaginatedResponse viven en modules/team; promoverlos a src/shared/ toca los consumidores del módulo team, fuera del alcance de este PR
import type {
  FilterTeamUsers,
  UsersTeamPaginatedResponse,
} from '@/modules/team/types/users.type';

export const teamUserService = {
  /**
   * Obtiene la lista de usuarios del equipo según los filtros proporcionados.
   * @param params - Parámetros para filtrar los usuarios del equipo. `levels` sale como
   * parámetro repetido (`levels=1&levels=2`), que es lo que Spring bindea; Axios por defecto manda `levels[]=1`.
   * @returns Promesa con el resultado tipado usando Either (ApiResult<UsersTeamPaginatedResponse>).
   */
  getTeamUsers(
    params: FilterTeamUsers
  ): Promise<ApiResult<UsersTeamPaginatedResponse>> {
    return executeRequest(() =>
      http.get<UsersTeamPaginatedResponse>('company/b2b/teams/users', {
        params,
        paramsSerializer: { indexes: null },
        headers: {
          'X-API-VERSION': '2',
        },
      })
    );
  },
};
